(function ($) {
    $(window).on('load', function () {
        $('#gsc-i-id1').attr('placeholder', 'What are you looking for?');
        $('#gsc-i-id2').attr('placeholder', 'What are you looking for?');

        if ($("#uber").hasClass("interior")) {
            if (window.location.hash) {
                anchorOffset(window.location.hash.substring(1));
            }
        }

        adjustIdLikeToDD();
    }).on('resize', function () {
        adjustIdLikeToDD();
    });

    var idLikeTo = $('#idLikeToDropdown'),
        maxH = idLikeTo.css('max-height');

    function adjustIdLikeToDD() {
        if ($(window).height() * 0.8 < parseInt(maxH)) {
            idLikeTo.css('max-height', $(window).height() * 0.8);
        } else {
            idLikeTo.css('max-height', maxH);
        }
    }

    $('#printAreaContent a[href*=#]:not([href=#]), #printAreaContentDotNet a[href*=#]:not([href=#]), #skipContentLink').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + decodeURI(this.hash.slice(1)).replace(/\s|[`~!@#$%^&*()|+\=?;:'",.<>\{\}\[\]\\\/]/gi, '') + ']');
            if (target.parents('.AccordionContent').length || target.parents('.AccordionTrigger').length) { //if clicking accordion link or link in accordion

                if (target.parents('.AccordionTrigger').length) {
                    target.closest('.AccordionTrigger').addClass('open');
                    target.closest('.AccordionTrigger').next().slideDown("100");
                } else if (target.parents('.AccordionContent').length) {
                    $('.AccordionContent:visible').slideUp("100");
                    $('.AccordionTrigger').removeClass('open');
                    target.parents('.AccordionContent').slideDown("100");
                    target.parents('.AccordionContent').prev().addClass('open');
                }
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - headerHeight //Offset scroll position of anchor link for sticky header
                    }, 1000);
                    target.focus();
                    return false;
                }
            } else if (target.length) {
                $viewport.stop().animate({
                    scrollTop: target.offset().top - headerHeight //Offset scroll position of anchor link for sticky header
                }, 1000);
                target.focus();
                return false;
            }
        }
    });

    function anchorOffset(anchor) {
        // Offset scroll position of anchor link for sticky header
        var anchorIsEl = true;
        if (anchor.match("^#")) {
            anchor = anchor.replace("#", "");
        }

        if ($("[name=" + anchor + "]").parents('.AccordionTrigger').length) {
            $("[name=" + anchor + "]").closest('.AccordionTrigger').addClass('open');
            $("[name=" + anchor + "]").closest('.AccordionTrigger').next().slideDown("100");
        } else if ($("[name=" + anchor + "]").parents('.AccordionContent').length) {
            $('.AccordionContent:visible').slideUp("100");
            $('.AccordionTrigger').removeClass('open');
            $("[name=" + anchor + "]").parents('.AccordionContent').slideDown("100");
            $("[name=" + anchor + "]").parents('.AccordionContent').prev().addClass('open');
        }

        if (anchor != "") {
            if ($("[name=" + anchor + "]").length > 0) {
                anchor = $("[name=" + anchor + "]");
            } else if ($("#" + anchor).length > 0) {
                anchor = $("#" + anchor);
            } else {
                anchorIsEl = false;
            }
            if (anchorIsEl) {
                var offsetTop = anchor.offset().top;
                if ($(window).height() > 500) {
                    offsetTop = offsetTop - $("header").height();
                }
                $("html, body").animate({
                        scrollTop: offsetTop
                    },
                    1000
                );
            }
        }
    }
})(jQuery);